const ruTranslations = {
    menu: {
        about: "О компании",
        services: "Услуги",
        partners: "Партнеры",
        contacts: "Контакты"
    },

    aboutInfo: {
        title: "О компании",
        description: "Наша команда специализируется на проектировании и внедрении систем безопасности.",
        main: "Компания “Hover Systems” OОО была основана в 2022 году. Наша команда специализируется на проектировании и внедрении систем безопасности, включая системы пожарной сигнализации, системы оповещения голосом, контроль доступа, видеонаблюдение, системы вызова персонала, гостиничные замки и телекоммуникационные системы. Инженерный состав компании имеет около 15 лет опыта работы в области систем безопасности и за это время получил многочисленные сертификаты от ведущих европейских брендов."
    },

    services: {
        title: "Услуги",
        description: "Мы реализуем лучшие решения вместе с нашими высококвалифицированными специалистами",
        service1: "Системы автоматической пожарной сигнализации",
        service2: "Системы газового пожаротушения",
        service3: "Системы оповещения и управления эвакуацией",
        service4: "Системы охранной сигнализации",
        service5: " Системы контроля управления доступом",
        service6: " Системы вызова персонала",
        service7: "Системы электронных замков для гостиниц",
        service8: "Энергосберегающие системы для гостиниц",
        service9: "Телекоммуникационные сети",
        service10: "Системы видеонаблюдения",
    },

    companies: {
        title: "Компании",
        description: "Компании, с которыми мы сотрудничаем",
    },
  
    contacts: {
        title: "Контакты",
        description: "Обращайтесь к нам с любыми вопросами.",
        founder: "Оганнес У. Алавердян",
        position: "Основатель и директор компании “Hover Systems”  OОО",
        addressLabel: "Адрес:",
        address: " Армения, г. Ереван, Мамиконянц 27",
        telLabel: "Телефон:",
        tel: "+374 95 64 61 23",
        emailLabel: "Эл. адрес:",
        email: "info@hoversystems.am",
        email2: "hoversystemsarmenia@gmail.com"
    },
};

export default ruTranslations;

